import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/modelService/account.service';
import { CommitteeService } from 'src/app/services/modelService/committee.service';

@Component({
  selector: 'app-donation-list',
  templateUrl: './donation-list.component.html',
  styleUrls: ['./donation-list.component.scss'],
})
export class DonationListComponent implements OnInit {
  @Input() type: string;
  constructor(public cs: CommitteeService, public ac: AccountService, private router: Router) { }

  ngOnInit() {
    this.ac.getDonationList();
  }


  clickDonation(id) {
    if (id) {
      this.router.navigate(['/donation-details/'+this.cs.committee.id, id])
    } else {
      this.router.navigate(['/donation-edit/'+this.cs.committee.id ])
    }
  }
}
